import { render, staticRenderFns } from "./PremiumStatus.vue?vue&type=template&id=0f30a56b&"
import script from "./PremiumStatus.vue?vue&type=script&lang=js&"
export * from "./PremiumStatus.vue?vue&type=script&lang=js&"
import style0 from "./PremiumStatus.vue?vue&type=style&index=0&id=0f30a56b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports